// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true
    },
};

// Declare Templates
var bcSfFilterTemplate = {
    'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop action_button" data-gallery="product-{{itemId}}-gallery">' + bcSfFilterConfig.label.quick_shop + '</span>',
    'newRowHtml': '<br class="clear product_clear" />',

    // Grid Tempate
    'productGridItemHtml': '<div class="{{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupMobileClass}} swap-' + bcSfFilterConfig.custom.collection_secondary_image + '" data-qvurl="{{itemQvUrl}}" itemprop="itemListElement" itemscope itemtype="http://schema.org/Product">' +
                                '<a href="{{itemUrl}}" itemprop="url">' +
                                    '<div class="relative product_image"><div class="product_container">{{itemImages}}</div></div>' +
                                    '<div class="info">' +
                                        '<span class="title" itemprop="name">{{itemTitle}}</span>' +
                                        '{{itemVendor}}' +
                                        '{{itemPrice}}' +
                                    '</div>' +
                                    '{{itemLabels}}' +
                                '</a>' +
                                '{{itemQuickViewBtn}}' +
                            '</div>' +
                            '{{itemNewRow}}',

    // Pagination Template
    'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + bcSfFilterConfig.label.paginate_prev + '</a></span>',
    'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.paginate_next + ' »</a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<select>{{sortingItems}}</select>'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    var saleClass = onSale ? 'sale' : '';

    var itemColumnNumberClass = '';
    var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, bcSfFilterConfig.custom.products_per_row);
    var itemCollectionGroupMobileClass = (index - 1) % 2 == 0 ? 'even' : 'odd';
    if (bcSfFilterConfig.custom.sidebar_enable) {
        switch (bcSfFilterConfig.custom.products_per_row) {
            case 2: itemColumnNumberClass = 'six columns'; break;
            case 3: itemColumnNumberClass = 'four columns'; break;
            default: itemColumnNumberClass = 'three columns'; break;
        }
    } else {
        switch (bcSfFilterConfig.custom.products_per_row) {
            case 2: itemColumnNumberClass = 'eight columns'; break;
            case 3: itemColumnNumberClass = 'one-third column'; break;
            default: itemColumnNumberClass = 'four columns'; break;
        }
    }
    itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);    
    itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);    
    itemHtml = itemHtml.replace(/{{itemCollectionGroupMobileClass}}/g, itemCollectionGroupMobileClass);

    // Add Quickview button
    var itemQuickViewBtnHtml = '<div class="quick_shop_container">';
    if (bcSfFilterConfig.custom.quick_shop_enable) {
        itemQuickViewBtnHtml += bcSfFilterTemplate.quickViewBtnHtml;
    }
    itemQuickViewBtnHtml += '</div>';
    itemHtml = itemHtml.replace(/{{itemQuickViewBtn}}/g, itemQuickViewBtnHtml);

    // Add Thumbnail
  	var product_aspect_ratio = '';
  	var align_height_value = '';
    if (bcSfFilterConfig.custom.align_height) {
		var collection_height = bcSfFilterConfig.custom.collection_height;
        var product_aspect_ratio = data['featured_image']['width'] / data['featured_image']['height'];
		var product_set_width = product_aspect_ratio * collection_height;
      	if (data['featured_image']['width'] >= data['featured_image']['height']) {
          	align_height_value = 'width: 100%; height: auto;';
        } else {
          	align_height_value = 'width: 100%;';
        }
	}
  	if (bcSfFilterConfig.custom.align_height) {
        var maxWidth = 'max-width: ' + product_set_width + 'px';
    } else {
      	var maxWidth = 'max-width: ' + data['featured_image']['width'] + 'px';
    }
  	// Get image source
  	var imageSrc = 'data-src="' + this.getFeaturedImage(images, '2048x') + '" ';
    imageSrc += 'data-srcset=" ' + this.getFeaturedImage(images, '2048x') + ' 2048w,';
    imageSrc += this.getFeaturedImage(images, '1600x') + ' 1600w,';
    imageSrc += this.getFeaturedImage(images, '1200x') + ' 1200w,';
    imageSrc += this.getFeaturedImage(images, '1000x') + ' 1000w,';
    imageSrc += this.getFeaturedImage(images, '800x') + ' 800w,';
    imageSrc += this.getFeaturedImage(images, '600x') + ' 600w,';
    imageSrc += this.getFeaturedImage(images, '400x') + ' 400w"';
  	// Build images
	var itemImagesHtml = '<div class="image__container" style="' + maxWidth + '">';
    itemImagesHtml += '<img  src="' + this.getFeaturedImage(images, '300x') + '"' +
                            'alt="{{itemTitle}}" ' +
                            'class="lazyload lazyload--fade-in" ' +
                            'style="' + align_height_value + ' max-width: ' + data['featured_image']['width'] + 'px;" '+
                            'data-sizes="auto" ' + imageSrc + '/>';
                           
    if (bcSfFilterConfig.custom.collection_secondary_image) {
        var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src'], '900x') : this.getFeaturedImage(images, '900x');
      	itemImagesHtml += '<div class="image__container" style="max-width: ' + itemFlipImageUrl + 'px; ">';
        itemImagesHtml += '<img src="' + itemFlipImageUrl + '" alt="{{itemTitle}}" class="secondary lazyload" />';
      	itemImagesHtml += '</div>';
    }
  	itemImagesHtml += '</div>';
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.display_vendor_collection) {
        itemVendorHtml += '<span class="vendor" itemprop="brand">' + data.vendor + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Labels
    var itemLabelsHtml = '';
    if (bcSfFilterConfig.custom.sale_banner_enabled && data.compare_at_price_max > data.price_min) {
        itemLabelsHtml += '<div class="sale_banner">' + bcSfFilterConfig.label.sale + '</div>';
    } 
    // Get Label (New, Comming soon, Pre order) from Collection
    if (data.collections) {
        var newLabel = data.collections.filter(function(e) { return e.handle == 'new'; });
        itemLabelsHtml += typeof newLabel[0] != 'undefined' ? '<div class="new_banner">' + bcSfFilterConfig.label.new + '</div>' : '';

        var comingsoonLabel = data.collections.filter(function(e) { return e.handle == 'coming-soon'; });
        itemLabelsHtml += typeof comingsoonLabel[0] != 'undefined' ? '<div class="new_banner">' + bcSfFilterConfig.label.coming_soon + '</div>' : '';

        var preorderLabel = data.collections.filter(function(e) { return e.handle == 'pre-order'; });
        itemLabelsHtml += typeof preorderLabel[0] != 'undefined' ? '<div class="new_banner">' + bcSfFilterConfig.label.pre_order + '</div>' : '';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
    
    // Add Price
    var stockClass = data.available ? 'InStock' : 'OutOfStock';
    var itemPriceHtml = '';
    if (typeof comingsoonLabel[0] == 'undefined') {
        itemPriceHtml += '<span class="price ' + saleClass + '" itemprop="offers" itemscope itemtype="http://schema.org/Offer">';
                         '<meta itemprop="price" content="' + data.price_min + '" />'
                         '<meta itemprop="priceCurrency" content="' + bcSfFilterConfig.shop.currency + '" />' +
                         '<meta itemprop="seller" content="' + bcSfFilterConfig.shop.name + '" />' +
                         '<link itemprop="availability" href="http://schema.org/' + stockClass + '">' + 
                         '<meta itemprop="itemCondition" content="New" />';
        if (!soldOut) {
            if (priceVaries && data.price_min > 0) {
                itemPriceHtml += '<small><em>' + bcSfFilterConfig.label.from_price + ' </em></small>';
            }
            if (data.price_min > 0) {
                itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
            } else {
                itemPriceHtml += bcSfFilterConfig.label.free_price;
            }
            if (onSale) {
                itemPriceHtml += ' <span class="was_price">' +
                                    '<span class="money">' + this.formatMoney(data.compare_at_price_max) + '</span>' +
                                 '</span>';
            }
        } else {
            itemPriceHtml += '<span class="sold_out">' + bcSfFilterConfig.label.sold_out + '</span>';
        }
        itemPriceHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add new row
    var itemNewRowHtml = index % bcSfFilterConfig.custom.products_per_row == 0 ? bcSfFilterTemplate.newRowHtml : '';
    itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRowHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{itemQvUrl}}/g, '/products/' + data.handle);

    return itemHtml;
};

// Build advanced class
function buildItemCollectionGroupThumbClass(index, productsPerRow) {
    var temp = index < productsPerRow ? index : index % productsPerRow;
    if (temp == 0) { return 'omega'; }
    else if (temp == 1) { return 'alpha'; }
    return '';
}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    counter = 1;
    
    for (var k in data) {
        // Featured image
        if (data[k]['images_info'].length > 0) {
            data[k]['featured_image'] = data[k]['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    // Build content for Quick view
    jQ('.thumbnail').each(function (e) {
        var _this = this;
        var url = jQ(this).data("qvurl");
        jQ.ajax({
            type: "GET",
            url: url + '?view=quickview',
            success: function(data){
                jQ(data).insertAfter(jQ(_this));
            }
        });
    });
  if(window.collection){
    if(window.collection.init){
    	collection.init()
    }
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
    // Add Wrapper for Product list
    if (jQ('#bc-sf-filter-products').children().hasClass('product-list')) {
        jQ('#bc-sf-filter-products').children().children().unwrap();
    }
};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
